'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _memberCompliance = require('./member-compliance.component');

var _memberCompliance2 = _interopRequireDefault(_memberCompliance);

var _memberCompliance3 = require('./member-compliance.service');

var _memberCompliance4 = _interopRequireDefault(_memberCompliance3);

var _compliantMembers = require('./compliant-members/compliant-members.module');

var _compliantMembers2 = _interopRequireDefault(_compliantMembers);

var _noncompliantMembers = require('./noncompliant-members/noncompliant-members.module');

var _noncompliantMembers2 = _interopRequireDefault(_noncompliantMembers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.admin.member-compliance', [_angularUiRouter2.default, _compliantMembers2.default, _noncompliantMembers2.default]).component('memberCompliance', _memberCompliance2.default).service('MemberComplianceService', _memberCompliance4.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('memberCompliance', {
    parent: 'memberComplianceProcess',
    url: '/member-compliance',
    component: 'memberCompliance',
    resolve: {
      compliantCompanies: function compliantCompanies(MemberComplianceService) {
        return MemberComplianceService.getCompliantCompanies().then(function (r) {
          return r.data;
        });
      },
      nonCompliantCompanies: function nonCompliantCompanies(MemberComplianceService) {
        return MemberComplianceService.getNonCompliantCompanies().then(function (r) {
          return r.data;
        });
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/member-compliance.module.js